import { ChangeDetectionStrategy, Component, inject, Input, OnInit, SecurityContext } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RichTextComponent } from 'src/app/shared/components/rich-text/rich-text.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'que-text-to-question-display',
    imports: [CommonModule, RichTextComponent, ReactiveFormsModule, FormsModule],
    templateUrl: './text-to-question-display.component.html',
    styleUrls: ['./text-to-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextToQuestionDisplayComponent implements OnInit {
  @Input()
  question?: Question;
  @Input() viewAnswer = false;
  sanitizedHtml?: SafeHtml;
  html?: string;
  #sanitizer = inject(DomSanitizer);
  valueControl = new FormControl()
  ngOnInit(): void {
    this.valueControl.setValue(this.question?.additionalText)
    // if (this.question?.text) {
    //   this.sanitizedHtml = this.#sanitizer.bypassSecurityTrustHtml(this.question?.text);
    //   //this.html = this.#sanitizer.sanitize(SecurityContext.HTML, this.question?.text)??"";
    // }
  }
}